import { render, staticRenderFns } from "./WelcomeSignOverrides.vue?vue&type=template&id=35f46f30"
import script from "./WelcomeSignOverrides.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeSignOverrides.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports